import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import type {
  SwidgeGetOutput,
  SwidgeListOutput,
} from '@infinex/main-service-contract/v2/client/swidge';

import type { QueryOptionsV2 } from '../config';
import { getApiClientV2, getTRPCClient } from '../config';

export const useSwidgeListQuery = (
  options?: QueryOptionsV2<SwidgeListOutput, SwidgeListOutput>
) =>
  useQuery(
    getTRPCClient().swidge.swidgeList.queryOptions(
      { page: 1, pageSize: 100 },
      { staleTime: 30 * 1000, ...options }
    )
  );

/**
 * Query hook to get a specific swidge order by ID.
 */
export const useSwidgeGetQuery = (
  params: { id: string },
  options?: QueryOptionsV2<SwidgeGetOutput, SwidgeGetOutput>
) =>
  useQuery(
    getTRPCClient().swidge.swidgeGet.queryOptions(params, {
      staleTime: 5 * 1000,
      ...options,
    })
  );

/**
 * Used in the swidge feature only, injected as a dependency that returns
 * a `{ queryKey, queryFn }` pair compatible with `SwidgeDependencyContext`.
 * Mirrors the v1 behaviour of swallowing errors as `null`.
 */
export const useBuildSwidgeOrderDetailQueryOptions = () => {
  const getSwidgeOrderDetailQueryOptions = useCallback((id: string) => {
    const queryOptions = getTRPCClient().swidge.swidgeGet.queryOptions({ id });
    return {
      queryKey: queryOptions.queryKey,
      queryFn: () =>
        getApiClientV2()
          .swidge.swidgeGet.query({ id })
          .catch(() => null),
    };
  }, []);

  return { getSwidgeOrderDetailQueryOptions };
};
